import { User } from '@supabase/supabase-js';

export interface RequireUserOptions {
  user: User | null;
  navigate: (path: string) => void;
  currentPath: string;
  action?: () => void;
  /** If true, defaults to signup tab instead of signin */
  preferSignup?: boolean;
}

/**
 * Gate an action behind login. Redirects to /auth with returnTo if not logged in.
 */
export function requireUser({ user, navigate, currentPath, action, preferSignup }: RequireUserOptions) {
  if (!user) {
    const returnTo = encodeURIComponent(currentPath + window.location.search);
    const modeParam = preferSignup ? '&mode=signup' : '';
    navigate(`/auth?returnTo=${returnTo}${modeParam}`);
    return;
  }

  if (action) {
    action();
  }
}
